var exports = {
  "kL": "MobileBottomNavSkeleton.module__container___R25JMW",
  "pc": "MobileBottomNavSkeleton.module__navItem___R25JMW",
  "hk": "MobileBottomNavSkeleton.module__navItemLabel___R25JMW",
};

module.exports = exports;
